// src/layout/DashboardLayout.jsx

import React, { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

export default function DashboardLayout() {

  const navigate = useNavigate();
  const location = useLocation();

  const user = JSON.parse(localStorage.getItem("user"));
  const role = user?.role || "";

  useEffect(() => {
    if (location.pathname === "/dashboard" && role !== "it_admin") {
      navigate("/dashboard/ai-recordings");
    }
  }, [location, role, navigate]);

  return (
    <div className="d-flex flex-column vh-100">

      <Navbar user={user} />

      <div className="d-flex flex-grow-1">

        <div style={{ width: "220px" }} className="border-end bg-light">
          <Sidebar role={role} />
        </div>

        <div className="flex-grow-1 p-3 overflow-auto">
          <Outlet />
        </div>

      </div>
    </div>
  );
}